<template>
  <div>
    <div class="ta-buyer-premium-terms-wrapper alert alert-info">
      <p class="ta-buyer-premium-statement">{{ $t('The following buyer premiums will apply') }}</p>
      <div v-for="(premium, ind) of lot.auction.premium_terms" :key="ind" class="ta-buyer-premium-tier">
        <div>{{ premium.percent }}% {{ $t('premium') }}</div>
        <div v-if="lot.auction.premium_terms.length > 1">{{ $t('Over') }} {{ premium.amount_over | asCurrency(lot.currency.code) }}</div>
      </div>
      <template v-if="minimumPremium">
        <hr>
        <div class="ta-buyer-premium-tier ta-buyer-premium-minimum">
          <div>{{ $t('Minimum Premium') }}:</div>
          <div>{{ minimumPremium | asCurrency(lot.auction.currency.code) }}</div>
        </div>
      </template>
    </div>

    <div class="ta-tax-rate-info-message">
      <template v-if="!lot.is_vat_applicable_for_hammer_price">
        {{ $t('VAT does not apply on the Hammer Price') }}
      </template>
      <template v-else>
        {{ $t('VAT - {vat_rate} applies on the Hammer Price', {vat_rate: lot.tax_rate + "%"}) }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaxRateAndPremiums",
  props: {
    lot: {
      type: Object,
      required: true
    }
  },
  computed: {
    minimumPremium() {
      return parseFloat(this.lot.auction.minimum_premium || 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.ta-buyer-premium-tier {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.ta-tax-rate-info-message {
  margin-bottom: 1rem;
}

#artisioTimedAuctions {
  .ta-buyer-premium-statement {

  }
}
</style>
